import Util from "@/Master/Util";
import EventManager from "@/Fwk/EventManager";
import { masterEvent } from "@/Master/Const/MasterEvent";
import FrameOrientMgr from "@/Master/FrameOrient/FrameOrientMgr";
import KitPwa from "@/Master/PWA/KitPwa";
import UtilBrowser from "@/Master/UtilBrowser";
import { confJson } from "@/app/config/confJson";
import DuMgr from "@/Fwk/SM/DuMgr";
import {GameInitConfig} from "@/Core/Bridge/UnityConfig";
import {CallJSSKey} from "@/Core/Bridge/CallJSSKey";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import CallTempData from "@/Core/Bridge/CallTempData";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";
import {GameMsgKey} from "@/app/(game)/GameMsgKey";
import DataMgr from "@/Fwk/DataMgr";
import {getLocalRewardType, isLoginAccount} from "@/app/utils/auth";

// 定义与 Unity 交互的消息接口
interface UnityMessage {
    key: string;
    strValue: string;
    intValue: number;
}

export default class CallJSS {
    static tag: string = `[CallJSS]`;

    /**
     * 封装日志输出，统一管理日志格式和开关
     * @param message 日志消息
     */
    private static log(message: string, ...optionalParams: any[]) {
        if (Util.isLog) {
            console.log(this.tag, message, ...optionalParams);
        }
    }

    /**
     * 初始化 CallJSS，设置可见性变化监听器
     */
    static Init(): void {
        this.log('Hello');

        // 设置页面可见性变化的监听器
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        document.addEventListener("resize", this.onResize);
    }

    /**
     * 游戏初始化方法
     */
    static GameInit(): void {
        this.log('Hello GameInit');
        // 在此处添加游戏初始化逻辑
    }

    private static onResize(){
        this.On(CallJSSKey.LayoutRefresh, 'onResize', 0);
    }

    /**
     * 处理可见性变化事件
     */
    private static handleVisibilityChange = (): void => {
        if (document.visibilityState === "hidden") {
            this.On(CallJSSKey.OnDocumentHidden, 'data', 0);
            this.log(`onDocumentHidden`);
            EventManager.dispatchEvent(masterEvent.onVisibilitychangeHide);
        } else {
            this.On(CallJSSKey.OnDocumentVisible, 'data', 0);
            this.log(`onDocumentVisible`);
            setTimeout(() => {
                GameMsgUtil.sendMsgParent({
                    type: GameMsgKey.game_frame_orient_update,
                })
            });
            let count = 0;
            const updateInter = setInterval(() => {
                count++;
                GameMsgUtil.sendMsgParent({
                    type: GameMsgKey.game_frame_orient_update,
                })
                if (count > 3) {
                    clearInterval(updateInter);
                }
            }, 100);

            EventManager.dispatchEvent(masterEvent.onVisibilitychangeShow);
        }
    };


    /**
     * 发送消息到 Unity
     * @param key 消息 key
     * @param strValue 字符串值
     * @param intValue 整数值
     */
    static On(key: CallJSSKey, strValue: string, intValue: number): void {
        this.log(`On => key=${key}, strValue=${strValue}, intValue=${intValue}`);

        if (window.unityInstance) {
            const message: UnityMessage = { key, strValue, intValue };
            const jsonStr = JSON.stringify(message);
            this.log(`On => SendMessage('WebGLBridge', 'CallUnity', ${jsonStr})`);
            window.unityInstance.SendMessage('WebGLBridge', 'CallUnity', jsonStr);
        }
    }

    /**
     * 执行特定操作
     * @param key 操作 key
     * @param intVal 整数值
     * @param booleanVal 布尔值
     * @param strVal 字符串值
     */
    static Do(key: CallJSSKey, intVal: number, booleanVal: boolean, strVal: string): void {
        this.log(`Do => key=${key}, intVal=${intVal}, booleanVal=${booleanVal}, strVal=${strVal}`);

        GameMsgUtil.sendMsgParent({
            type:GameMsgKey.game_do_type,
            doKey:key,
            doIntVal:intVal,
            doBooleanVal:booleanVal,
            doStrVal:strVal,
        });

        switch (key) {
            case CallJSSKey.GeoRequestFingerprint:
                break;
            case CallJSSKey.GeoRequestLocation:
                break;
            case CallJSSKey.GeoQueryGps:
                break;
            case CallJSSKey.HideIframeDialog:
                // 实现 HideIframeDialog 逻辑（如有需要）
                break;
            case CallJSSKey.SetForcedLandscape://游戏设置强制横竖屏幕
                if (intVal === 1){
                    GameMsgUtil.sendMsgParent({type: GameMsgKey.game_frame_horizontal});
                }else{
                    GameMsgUtil.sendMsgParent({type: GameMsgKey.game_frame_vertical});
                }
                break;
            case CallJSSKey.CloseOpener:
                // 实现 CloseOpener 逻辑（如有需要）
                break;
            case CallJSSKey.HideLoading:
                // 实现 HideLoading 逻辑（如有需要）
                break;
            case CallJSSKey.ShowKeyboard:
                // 实现 ShowKeyboard 逻辑（如有需要）
                break;
            case CallJSSKey.HideKeyboard:
                // 实现 HideKeyboard 逻辑（如有需要）
                break;
            case CallJSSKey.InstallPWA:
                // Util.sendMessageToParent({ types: masterConst.OnInstallPwa, val: intVal });
                break;
            case CallJSSKey.LoadProgress:
                EventManager.dispatchEvent(masterEvent.onUnityLoadProgress,intVal);
                break;
            default:
                console.warn(`${this.tag} 未知的 Do key: ${key}`);
        }
    }

    /**
     * 跳转操作
     * @param key 跳转 key
     * @param strValue 字符串值
     * @param intValue 整数值
     * @returns 是否成功
     */
    static Jump(key: CallJSSKey, strValue: string, intValue: number): boolean {
        this.log(`Jump => key=${key}, strValue=${strValue}, intValue=${intValue}`);

        switch (key) {
            case CallJSSKey.JumpEmail:

                break;
            case CallJSSKey.JumpUrl:

                break;
            case CallJSSKey.Url:
                // FrameOrientMgr.setIframeRotate90Forced();
                break;
            default:
                console.warn(`${this.tag} 未知的 Jump key: ${key}`);
        }
        return false;
    }

    /**
     * 设置特定值或执行操作
     * @param key 方法名/协议名
     * @param intValue 整数或字符串值
     * @param booleanValue 布尔值
     * @param strVal1 字符串值1
     * @param strVal2 字符串值2
     */
    static Set(key: CallJSSKey, intValue: number, booleanValue: boolean, strVal1: string, strVal2: string): void {
        this.log(`Set => key=${key}, intStr=${intValue}, booleanValue=${booleanValue}, strVal1=${strVal1}, strVal2=${strVal2}`);

        let attr: Record<string, any> = {};

        GameMsgUtil.sendMsgParent({
            type:GameMsgKey.game_set_type,
            setKey:key,
            intValue:intValue,
            booleanValue:booleanValue,
            strVal1:strVal1,
            strVal2:strVal2,
        });

        switch (key) {
            case CallJSSKey.TrackChannel:
            case CallJSSKey.TrackThirdChannel:
                // SdkTrack.trackThirdChannel(strVal1, strVal2);
                break;
            case CallJSSKey.TrackGA4:
                // SdkTrack.trackGA4Event(strVal1, strVal2);
                break;
            case CallJSSKey.TrackFirebaseEvent:
                // SdkTrack.trackGA4Event(strVal1, { "USD": strVal2 });
                // SdkTrack.trackPixelEvent(strVal1, { currency: "USD", value: strVal2 });
                break;
            case CallJSSKey.TrackPixel:
                // SdkTrack.trackPixelEvent(strVal1, strVal2);
                break;
            case CallJSSKey.TrackAdjust:
                // SdkTrack.trackAdjust1(strVal1, strVal2);
                break;
            case CallJSSKey.Track:
                try {
                    attr = JSON.parse(strVal2);
                    const maps = new Map(Object.entries(attr));
                    // SdkTrack.track513Commit(strVal1, null, null, maps);
                } catch (error) {
                    console.error(`${this.tag} track 的 JSON 无效:`, error);
                }
                break;
            case CallJSSKey.WebDB:
                // DBMgr.UpdateData(strVal1, strVal2);
                break;
            default:
                console.warn(`${this.tag} 未知的 Set key: ${key}`);
        }
    }

    /**
     * 检查特定条件
     * @param key 检查 key
     * @param intValue 整数值
     * @param strValue 字符串值
     * @returns 布尔值
     */
    static Is(key: CallJSSKey, intValue?: number, strValue?: string): boolean {
        this.log(`Is => key=${key}, intValue=${intValue}, strValue=${strValue}`);

        let isOk = false;

        switch (key) {
            case CallJSSKey.loginAccountOk:
                isOk = isLoginAccount();
                break;
            case CallJSSKey.Tsetsi:
                isOk = Util.isTestMode;
                break;
            case CallJSSKey.Golsi:
                isOk = Util.isLog;
                break;
            case CallJSSKey.Development:
                isOk = Util.isTestMode;
                break;
            case CallJSSKey.IsInstalledPwa:
                isOk = KitPwa.isInstalled || KitPwa.isPlayPwa;
                break;
            case CallJSSKey.IsPlayPwa:
                isOk = KitPwa.isPlayPwa;
                break;
            case CallJSSKey.IsDesktop:
                isOk = UtilBrowser.isDesktop;
                break;
            case CallJSSKey.IsIOS:
                isOk = Util.isIOS || UtilBrowser.isSafari;
                break;
            case CallJSSKey.IsAndroid:
                isOk = Util.isAndroid;
                break;
            case CallJSSKey.IsGuidePwa:
                isOk = confJson.h5_mode === 1;
                break;
            case CallJSSKey.IsUserBuy:
                isOk = true;
                break;
            case CallJSSKey.OpenMoney://todo 网赚开关
                isOk = true;
                break;
            default:
                if (Util.isLog){
                    console.warn(`${this.tag} 未知的 Is key: ${key}`);
                }
                break;
        }

        this.log(`Is End => Key=${key} res=${isOk}`);

        return isOk;
    }

    /**
     * 获取字符串值
     * @param key 获取 key
     * @param intValue 整数值å
     * @param strValue 字符串值
     * @returns 字符串
     */
    static GetString(key: CallJSSKey, intValue?: number, strValue?: string): string {
        this.log(`GetString => key=${key}, intValue=${intValue}, strValue=${strValue}`);

        let back: string = "";
        switch (key) {
            case CallJSSKey.GameInitJson:
                const initConfig = new GameInitConfig();
                back =  initConfig.toString();
                break;
            case CallJSSKey.Header:
                back = CallTempData.getHeaderStr;
                break;
            case CallJSSKey.Config:
                back = JSON.stringify(confJson);
                break;
            case CallJSSKey.productId:
                back = `${confJson.productId}`;
                break;
            case CallJSSKey.releaseProductId:
                back = `${confJson.releaseProductId}`;
                break;
            case CallJSSKey.GetSMID:
                back = DuMgr.SMID;
                break;
            case CallJSSKey.GetSdkCfgStr:
                if (strValue == "game_api_url")
                    back = confJson.game_api_url;
                break;
            case CallJSSKey.deviceOrientation://todo 设备方向。1横屏幕 2竖屏幕
                back = FrameOrientMgr.isGetHorizontal ? '1' : '2';
                break;
            case CallJSSKey.rewardType:
                back = getLocalRewardType()+'';//
                break;
            case CallJSSKey.GaId:
            case CallJSSKey.GetWebUUID:
            case CallJSSKey.WebId:
                back = "0";//AdjustMgr.getWebUUID;
                break;
            case CallJSSKey.WebDB:
                strValue = typeof strValue === "string" ? strValue : "";
                if (strValue != null && strValue.length > 0)
                {
                    back = DataMgr.getStorage(strValue);
                }
                break;
        }
        this.log(`GetStringEnd => key=${key}, back=${back}`);
        return back;
    }

    /**
     * 获取整数值
     * @param key 获取 key
     * @param intValue 整数值
     * @param strValue 字符串值
     * @returns 整数
     */
    static GetInt(key: CallJSSKey, intValue?: number, strValue?: string): number {
        this.log(`GetInt => key=${key}, intValue=${intValue}, strValue=${strValue}`);
        let back: number = 0;
        switch (key)
        {
            case CallJSSKey.GetSdkCfgInt:
                if (strValue == "releaseProductId")
                    back = confJson.releaseProductId;
                break;
            case CallJSSKey.productId:
                back = confJson.productId;
                break;
            case CallJSSKey.releaseProductId:
                back = confJson.releaseProductId;
                break;
        }

        this.log(`GetInt2 => key=${key}, back=${back}`);
        // 根据需要实现逻辑
        return back;
    }

    /**
     * 获取浮点数值
     * @param key 获取 key
     * @param intValue 整数值
     * @param strValue 字符串值
     * @returns 浮点数
     */
    static GetFloat(key: CallJSSKey, intValue?: number, strValue?: string): number {
        this.log(`GetFloat => key=${key}, intValue=${intValue}, strValue=${strValue}`);
        // 根据需要实现逻辑
        return 0;
    }
}


